module.exports = __webpack_public_path__ + "img/48.7e46d3a8.svg";